import styled from '@emotion/styled';
import { Box, Typography, TypographyProps } from '@mui/material';

export const Title = styled(Typography) <TypographyProps>`
 padding-left: 8px;
 margin-bottom: -16px;
 z-index: 1;
 font-size: 2em;
 text-shadow: 2px 2px black;
`;

export const TableContainer = styled(Box)`
 padding-top: 8px;
`;

export const ImageBuild = styled(Box) <React.ImgHTMLAttributes<HTMLImageElement>>`
 width: 60px;
 height: auto;
`;
